<!--
 * @Author: 陈乾
 * @Date: 2021-10-26 15:36:54
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 15:01:25
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/components/icon/icon.vue
-->
<template>
  <div :class="`cq_icon ${_class}`" @click="$emit('onClick')">
    <i :class="'risen cq-' + name" :style="{ color, width: _iconSize, height: _iconSize, fontSize: _iconSize }"></i>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
export default {
  name: 'cqIcon',
  props: {
    _class: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 12
    },
    color: {
      type: String,
      default: 'red'
    }
  },
  computed: {
    // 通过计算属性，设置【图标】大小，如果是字符串则不做处理，否则加上rpx单位
    _iconSize() {
      return typeof this.size == 'string' ? this.size : `${this.size}px`
    }
  }
}
</script>

<style>
.cq_icon {
  line-height: 0;
}
</style>
